import styled from 'styled-components';
import { Body } from 'components/Typography';
import addAlpha from 'utils/addAlpha';
import DefaultButton from 'components/Buttons/Button';
import Placeholder from 'components/Placeholders/BasicPlaceholder';
import NoComments from 'assets/icons/no-comments.svg?react';

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Container = styled(Placeholder)``;

// TODO: TFR-45:Icon make unique name or do not export
export const Icon = styled(NoComments)`
  width: 5rem;
  height: 5rem;
  margin-bottom: 1.5rem;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.2)};
`;

// TODO: TFR-45:Title make unique name or do not export
export const Title = styled(Body)`
  font-weight: 600;
  margin-bottom: 1.875rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Button = styled(DefaultButton)``;
